module.exports = __webpack_public_path__ + "img/nav-design-fancy@2x.128d909.webp";